import { Noun } from '../../types'

const пиздец: Noun = {
  type: 'noun',
  nominativeSingular: 'пиздец',
  genitiveSingular: 'пиздеца',
  dativeSingular: 'пиздецу',
  accusativeSingular: 'пиздец',
  instrumentalSingular: 'пиздецом',
  prepositionalSingular: 'пиздеце',
  nominativePlural: 'пиздецы',
  genitivePlural: 'пиздецов',
  dativePlural: 'пиздецам',
  accusativePlural: 'пиздецы',
  instrumentalPlural: 'пиздецами',
  prepositionalPlural: 'пиздецах',
}

export default пиздец
